export default __webpack_public_path__ + "assets/img/ringgraphic_notification_wo_product.png";